import React, { useState } from "react";
// import {  FiShare2 } from "react-icons/fi"; // Icons update kiye hain
import { FiBookOpen, FiRefreshCw, FiShare2 } from "react-icons/fi";
import { FaHome } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import PracticeSolutions from "../../../practice-data/practice-solutions/PracticeSolutions";

const colorMap = {
  red: {
    bar: "bg-red-500 text-red-500",
    border: "border-l-red-500",
  },
  green: {
    bar: "bg-green-500 text-green-500",
    border: "border-l-green-500",
  },
  blue: {
    bar: "bg-blue-500 text-blue-500",
    border: "border-l-blue-500",
  },
  yellow: {
    bar: "bg-yellow-400 text-yellow-500",
    border: "border-l-yellow-400",
  },
};

const colorKeys = ["red", "green", "blue", "yellow"];

export default function SectionWisePerformance({ sections = [] }) {
  console.log('sections', sections);
  const navigate = useNavigate();
  const [showResult, setShowResult] = useState(false)

  if (!sections || sections.length === 0) return null;

  const goToDashboard = () => {
    navigate("/dashboard");
  };
  const retakeTest = () => {
    navigate("/exam-instructions");
  };

  const shareResults = async () => {
    const text = `📊 My Test Result

✅ Correct: 15
❌ Wrong: 5
⏭ Skipped: 2

🔥 Shared from Test App`;

    if (navigator.share) {
      await navigator.share({
        title: "My Test Result",
        text,
      });
    } else {
      toast.warn("Sharing is supported only on mobile browsers");
    }
  };

  const goToSolutions = () => {
    setShowResult(true)
  }

  if (showResult) {
    return <PracticeSolutions setShowResult={setShowResult} session={sections} />
  }

  return (
    <div className="max-w-[1400px] mx-auto px-3 py-4">
      <ToastContainer />
      <div>
        <h2 className="text-[28px] text-[#000000] tracking-tight font-[500] mb-6">
          Section-Wise Performance
        </h2>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {sections?.sectionWise.map((item, index) => {
            const colorKey = colorKeys[index % colorKeys.length];
            const color = colorMap[colorKey];

            return (
              <div
                key={index}
                className={`bg-white rounded-[10px] p-4 shadow-sm border-l-5 ${color.border}`}
              >
                <div className="flex justify-between items-center mb-4">
                  <h3 className="text-[20px] tracking-tight font-[500]">
                    {item?.sectionName}
                  </h3>
                  <span className={`text-[20px] tracking-tight font-[600] ${color.bar}`}>
                    {item?.score}
                  </span>
                </div>

                <p className="font-[500] text-[20px] tracking-tight text-[#000000] mb-3">
                  <span>{item?.percentage}%</span> Correct
                  <span className="float-right">Q {item?.totalQuestions}</span>
                </p>

                <div className="w-full bg-gray-200 rounded-full h-2 mb-3">
                  <div
                    className={`h-2 rounded-full ${color.bar.split(' ')[0]}`} // Sirf bg color use karne ke liye
                    style={{ width: `${item?.percentage}%` }}
                  />
                </div>

                <div className="flex justify-between font-[400] tracking-tight text-[14px] text-[#000000]">
                  <span>Correct: {item?.correct}</span>
                  <span>Incorrect: {item?.wrong}</span>
                  <span>Skipped: {item?.skipped}</span>
                </div>
              </div>
            );
          })}
        </div>

        {/* Action Buttons - Only 2 Options */}
        <div className="flex flex-wrap justify-center gap-4 my-10">

          {/* View Detailed Solutions */}
          <button
            onClick={goToSolutions}
            className="flex items-center gap-3 justify-center w-[280px] md:w-[250px] bg-red-500 hover:bg-red-600 text-white px-5 py-3 rounded-md text-[18px] font-medium transition-all"
          >
            <FiBookOpen className="text-[20px]" />
            View Detailed Solutions
          </button>

          {/* Retake Test */}
          <button
            onClick={retakeTest}
            className="flex items-center gap-3 justify-center w-[280px] md:w-[250px] bg-green-500 hover:bg-green-600 text-white px-5 py-3 rounded-md text-[18px] font-medium transition-all"
          >
            <FiRefreshCw className="text-[20px]" />
            Retake This Test
          </button>

          {/* Download Report */}
          <button
            onClick={goToDashboard}
            className="flex items-center gap-3 justify-center w-[280px] md:w-[250px] px-5 py-3 rounded-lg text-[18px] font-semibold bg-orange-500 text-white hover:bg-orange-600 active:scale-95 shadow-md hover:shadow-lg transition-all duration-200"
          >
            <FaHome className="text-[20px]" />
            Back Home
          </button>

          {/* Share Results */}
          <button
            onClick={shareResults}
            className="flex items-center gap-3 justify-center w-[280px] md:w-[250px] border border-gray-400 px-5 py-3 rounded-md text-[18px] font-medium bg-white hover:bg-gray-100 transition-all"
          >
            <FiShare2 className="text-[20px]" />
            Share Results
          </button>

        </div>
      </div>
    </div>
  );
}